import request from './request'
import { User, UserList, UserShiftData, UserShift } from './types/user'
import { AxiosResponse } from 'axios'

export const loadUser = async (): Promise<AxiosResponse<User>> => {
  return request.get<User>('/auth/who_am_i/', { withCredentials: true })
}

export const logoutUser = async (): Promise<AxiosResponse<{ detail: string }>> => {
  return request.post<{ detail: string }>('/auth/logout/')
}

export interface SendOtpPayload {
  contact: string
  login?: boolean
}

export interface VerifyOtpLoginPayload {
  otp: string
  contact: string
}

export interface VerifyOtpPayload {
  otp: string
  contact: string
  source?: string | null
}

export const sendOtpLogin = async (data: SendOtpPayload): Promise<AxiosResponse<unknown>> => {
  return request.post<unknown>('/users/send-otp', data)
}

export const sendOtp = async (contact: string): Promise<AxiosResponse<unknown>> => {
  return request.post<unknown>('/users/send-otp', { contact, login: false })
}

export const verifyOtp = async (data: VerifyOtpPayload): Promise<AxiosResponse<unknown>> => {
  return request.post<unknown>('/users/verify-otp', data, { withCredentials: true })
}

export const verifyOtpLogin = async (data: VerifyOtpLoginPayload): Promise<AxiosResponse<unknown>> => {
  return request.post<unknown>('/users/verify-otp-login', data)
}

export interface UsersSearchParams {
  // query?: string
  offset?: number
  limit?: number
  is_admin?: boolean
  is_driver?: boolean
  is_background_checker?: boolean
  is_ride_support?: boolean
  is_supervisor?: boolean
  is_business_partner?: boolean
}

export const getTgUsers = async (queryParams: UsersSearchParams): Promise<AxiosResponse<UserList>> => {
  const params = new URLSearchParams()

  Object.keys(queryParams).forEach((key) => {
    if (key && queryParams[key as keyof UsersSearchParams])
      params.append(`${key}`, String(queryParams[key as keyof UsersSearchParams]))
  })

  const response = await request.get<UserList>(`/tg-users/?${params.toString()}`)
  return response
}

export const listCompanyUsers = async (queryParams: UsersSearchParams = {}): Promise<AxiosResponse<UserList>> => {
  const params = new URLSearchParams()

  Object.keys(queryParams).forEach((key) => {
    const value = queryParams[key as keyof UsersSearchParams]
    if (value === undefined || value === null) return
    if (typeof value === 'boolean' && !value) return
    params.append(key, String(value))
  })

  const response = await request.get<UserList>(`/users/?${params.toString()}`)
  return response
}

export const getTgUser = async (id: number): Promise<AxiosResponse<User>> => {
  const data = await request.get<User>(`/tg-users/${id}/`)
  return data
}

export const getTgUserShifts = async ({
  userId,
  fromDate,
  toDate,
}: {
  userId: number
  fromDate: string
  toDate: string
}): Promise<AxiosResponse<UserShift[]>> => {
  const data = await request.get<UserShift[]>(
    `/shifts?telegram_user_id=${userId}&from_date=${fromDate}&to_date=${toDate}`,
  )
  return data
}

export const createTgUserShits = async (data: {
  telegram_user_id: number
  shift_data: UserShiftData[]
}): Promise<AxiosResponse<UserShift[]>> => {
  const response = await request.post<UserShift[]>(`/shifts/`, data)
  return response
}

export const editTgUser = async (data: User): Promise<AxiosResponse<User>> => {
  const response = await request.patch<User>(`/tg-users/${data.id}`, data)
  return response
}

export const editUser = async (data: Partial<User> & { id: number }): Promise<AxiosResponse<User>> => {
  const response = await request.patch<User>(`/users/${data.id}`, data)
  return response
}
